<template>

    <v-page-body>

        <v-page-section padded>
            <template #title>Native Integrations</template>
            <template #body>
                <v-list>
                    <v-list-item v-for="i in integrations" :key="i.id">
                        <div>
                            <v-icon class="mr-10" :symbol="'action-' + i.slug" :size="40" :radius="3" />
                            <span><router-link :to="`/settings/integrations/${i.slug}`">{{ i.name }}</router-link></span>
                        </div>
                        <div class="d-flex align-items-center justify-content-end">
                            <span class="small text-success mr-15" v-if="isConnected(i.id)">Connected</span>
                            <v-button size="sm" @click.native="$router.push(`/settings/integrations/${i.slug}`)">Edit</v-button>
                        </div>
                    </v-list-item>
                </v-list>
            </template>
        </v-page-section>

        <v-page-section padded>
            <template #title>Push Notifications</template>
            <template #body>
                <v-notice>
                    <template #body>
                        <p>To send web push notifications, you need to add the CrowdPower service worker file to the root of your website; typically the /public directory. After you have done this, <a href="https://docs.crowdpower.io/resources/push-notifications" target="_blank">follow these instructions</a> to request access from your customers to send push notifications.</p>
                    </template>
                    <template #footer>
                        <a id="download-service-worker" class="hidden" href="/service-worker.js" download="service-worker.js" />
                        <v-button @click.native="downloadServiceWorker">Download Service Worker</v-button>
                    </template>
                </v-notice>
            </template>
        </v-page-section>

    </v-page-body>

</template>

<script>

import axios from 'axios';
import IntegrationApi from '@api/IntegrationApi';
import ProjectApi from '@api/ProjectApi';

export default {

    data() {
        return {
            integrations: [],
            projectIntegrations: [],
        }
    },

    mounted() {
        this.reload();
    },

    methods: {

        reload() {
            this.$store.commit('loading', true);
            let requests = [
                IntegrationApi.getIntegrations(),
                ProjectApi.getIntegrations(this.project.id),
            ];
            axios.all(requests)
                .then(axios.spread((resIntegrations, resProjectIntegrations) => {
                    this.$store.commit('loading', false);
                    this.integrations = resIntegrations.data.data;
                    this.projectIntegrations = resProjectIntegrations.data.data;
                    this.$events.$emit('pageLoaded');
                }), () => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

        isConnected(id) {
            return this.projectIntegrations.find(i => i.integration_id === id) != null;
        },

        downloadServiceWorker() {
            document.getElementById('download-service-worker').click();
        },

    },

}

</script>